import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useCallback } from 'react';
import { ExprUtils } from '@/common/utils/ExprUtils';


export const McoDispList = ({ mcoInvLineId, partition }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.partition = partition;

    let whereParams = []
    if(mcoInvLineId){
      whereParams = whereParams.concat('mcoInvLineId', mcoInvLineId)
    }
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams(...whereParams));

  }, [mcoInvLineId]);

  return (
    <EntityList entity="MCO_DISP" augRowsReq={augRowsReq} />
  )
}